<template>
  <div>
    <!-- 客户编辑对话框（添加/修改） -->
    <van-dialog v-model="showEditDialog" :title="dialogTitle" show-cancel-button :confirm-button-loading="isOperating"
      :before-close="beforeClose">
      <div style="padding-right: 16px; box-sizing: border-box;">
        <van-field label="企业征信" :disabled="!!reportRecordId || isEditing">
          <template #input>
            <div class="history-select" @click="!!reportRecordId || isEditing || (showHistoryPopup = true)" :class="{ 'disabled': !!reportRecordId || isEditing }" style="width: 100%;">
              <span>{{ getSelectedText }}</span>
              <van-icon name="arrow-down" size="16px" color="#999" />
            </div>
          </template>
        </van-field>

        <!-- 企业征信选择弹窗 -->
        <van-popup v-model="showHistoryPopup" position="bottom" round>
          <div class="popup-header">
            <h3>选择企业征信</h3>
            <van-icon name="cross" size="20px" @click="showHistoryPopup = false" />
          </div>
          <van-list
            v-model="historyLoading"
            :finished="historyFinished"
            finished-text="没有更多了"
            @load="onLoadHistory"
          >
            <van-cell
              v-for="item in historyOptions"
              :key="item.value"
              @click="selectHistory(item)"
              :value="item.text"
            />
          </van-list>
        </van-popup>
      </div>
      <van-field v-model="editForm.bankName" label="借款银行" placeholder="请输入借款银行" />
      <van-field v-model="editForm.money" label="借款金额" placeholder="请输入借款金额" type="number" inputmode="numeric" pattern="^\d+$" />
      <van-field v-model="editForm.loansExpireTime" label="到期时间" placeholder="请选择到期时间" readonly
        @click="showTimePickerDialog = true" />
      <van-field v-model="editForm.remark" label="备注" placeholder="请输入备注信息" type="textarea" />
    </van-dialog>

    <!-- 时间选择器 -->
    <van-popup v-model="showTimePickerDialog" round position="bottom">
      <van-datetime-picker v-model="editForm.loansExpireTime" type="datetime" title="选择到期时间"
        @confirm="confirmTimePicker" @cancel="showTimePickerDialog = false" />
    </van-popup>
  </div>
</template>

<script>
import { Toast } from 'vant';
import user from '@/utils/user'
import request from "@/utils/request";
import {
  getMyReportRecords,
  getDepartmentReportRecords,
  getAllReportRecords,
} from "@/api/report";
import {
  getUpdateClient,
  getCreateClient,
} from "@/api/myclient";

export default {
  name: 'CustomerEditDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    reportRecordId: {
      type: String,
      default: ''
    },
    isAdding: {
      type: Boolean,
      default: false
    },
    clientId: {
      type: String,
      default: ''
    },
    messageId: {
      type: String,
      default: ''
    },
    loanType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      showEditDialog: false,
      dialogTitle: '',
      isEditing: false,
      showTimePickerDialog: false,
      showHistoryPopup: false,
      historyLoading: false,
      historyFinished: false,
      editForm: {
        id: '',
        userId: '',
        salesmanStr: '',
        money: '',
        loansExpireTime: '',
        bankName: '',
        remark: '',
        reportRecordId: '',
        firmId: 0,
        firmUserId: 0,
        loanType: 1,
      },
      duty: -1,
      loading: false,
      // 历史查询相关
      historyOptions: []
    };
  },
  watch: {
    visible: {
      handler(val) {
        if (this.showEditDialog !== val) {
          this.showEditDialog = val;
          if (val && this.messageId) {
            // 对话框打开时，设置消息已读
            this.setMessageRead(this.messageId);
          }
        }
      },
      immediate: true
    },
    showEditDialog(val) {
      if (this.visible !== val) {
        this.$emit('update:visible', val);
        if (!val) {
          // 对话框关闭时重置表单数据
          if (this.isAdding) {
            this.editForm = {
              id: '',
              userId: '',
              salesmanStr: '',
              money: '',
              loansExpireTime: '',
              bankName: '',
              remark: '',
              reportRecordId: this.reportRecordId || '',
              firmId: 0,
              firmUserId: 0,
              loanType: this.loanType,
            };
          }
        }
      }
    },
    clientId: {
      handler(val) {
        if (val) {
          this.getClientDetail(val);
        }
      },
      immediate: true
    },
    isAdding: {
      handler(val) {
        if (val) {
          this.dialogTitle = '添加客户';
          this.isEditing = false;
          this.editForm = {
            id: '',
            userId: '',
            salesmanStr: '',
            money: '',
            loansExpireTime: '',
            bankName: '',
            remark: '',
            reportRecordId: this.reportRecordId || '',
            firmId: 0,
            firmUserId: 0,
            loanType: this.loanType,
          };
        } else {
          this.dialogTitle = '修改客户';
          this.isEditing = true;
        }
      },
      immediate: true
    }
  },
  created() {
    this.duty = user.getUserDuty();
    this.getMyReportRecords();
  },
  computed: {
    // 计算是否正在操作中
    isOperating() {
      return this.loading;
    },
    // 获取选中的企业征信文本
    getSelectedText() {
      if (!this.editForm.reportRecordId) {
        return '请选择';
      }
      const selectedOption = this.historyOptions.find(option => option.value === this.editForm.reportRecordId);
      return selectedOption ? selectedOption.text : '请选择';
    }
  },
  methods: {
    // 获取客户详情
    getClientDetail(id) {
      this.loading = true;
      request.get("/User/ClientInfo/GetDetail", { params: { id } }).then((res) => {
        if (res.data && res.data.data) {
          this.editForm = Object.assign({}, res.data.data);
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    // 确认时间选择
    confirmTimePicker() {
      this.editForm.loansExpireTime = this.formatDateTime(this.editForm.loansExpireTime);
      this.showTimePickerDialog = false;
    },
    // 格式化日期时间
    formatDateTime(date) {
      if (!date) return '';
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const hours = String(d.getHours()).padStart(2, '0');
      const minutes = String(d.getMinutes()).padStart(2, '0');
      const seconds = String(d.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    // 获取历史报告记录
    getMyReportRecords() {
      const listQuery = {
        pageInfo: {
          pageSize: 9999,
          page: 1,
          totalCount: 0
        },
        orderBy: "createTime",
        orderAsc: true,
        employeeId: null,
        enterpriseNameLike: "",
      };
      if (this.duty == 1) {
        //普通员工
        getMyReportRecords(listQuery)
          .then((res) => {
            if (res.data && res.data.data) {
              this.historyOptions = res.data.data.data.map((item) => ({
                ...item,
                text: item.enterpriseName,
                value: item.id,
              }));
            }
          });
      } else if (this.duty == 2) {
        //小组长
        getDepartmentReportRecords(listQuery)
          .then((res) => {
            if (res.data && res.data.data) {
              this.historyOptions = res.data.data.data.map((item) => ({
                ...item,
                text: item.enterpriseName,
                value: item.id,
              }));
            }
          });
      } else if (this.duty == 3 || this.duty == 99) {
        //管理员
        getAllReportRecords(listQuery)
          .then((res) => {
            if (res.data && res.data.data) {
              this.historyOptions = res.data.data.data.map((item) => ({
                ...item,
                text: item.enterpriseName,
                value: item.id,
              }));
            }
          });
      }
    },
    // 选择历史记录
    selectHistory(item) {
      this.editForm.reportRecordId = item.value;
      this.showHistoryPopup = false;
    },
    // 加载历史记录
    onLoadHistory() {
      // 这里可以添加分页加载逻辑
      this.historyFinished = true;
      this.historyLoading = false;
    },
    // 标记消息已读
    setMessageRead(messageId) {
      request.get(`/Common/Message/SetRead?id=${messageId}`)
        .then(() => {
          // 消息已读设置成功后，通知父组件局部更新
          this.$emit('message-read', messageId);
        })
        .catch((error) => {
          console.error('标记消息已读失败:', error);
        });
    },
    // 对话框关闭前的回调
    beforeClose(action, done) {
      if (action === 'confirm') {
        // 表单验证
        if (!this.editForm.reportRecordId) {
          Toast('请选择企业征信');
          done(false); // 阻止对话框关闭
        } else if (!this.editForm.money || isNaN(Number(this.editForm.money)) || Number(this.editForm.money) <= 0 || !Number.isInteger(Number(this.editForm.money))) {
          Toast('请输入有效的借款金额（只能输入整数）');
          done(false); // 阻止对话框关闭
        } else {
          // 执行提交操作
          this.loading = true;

          if (!this.editForm.firmId) {
            this.editForm.firmId = 0
          }
          if (!this.editForm.firmUserId) {
            this.editForm.firmUserId = 0
          }

          if (this.isAdding) {
            this.editForm.loanType = this.loanType
          }

          // 添加客户 
          this.editForm.salesmanId = user.getCacheUserData().id;

          // 执行提交操作
          if (this.isAdding) {
            getCreateClient(this.editForm)
              .then(() => {
                Toast.success("添加客户成功");
                this.loading = false;
                this.$emit('submit-success');
                done(); // 允许对话框关闭
              })
              .catch(() => {
                Toast('添加失败，请重试');
                this.loading = false;
                done(false); // 阻止对话框关闭
              });
          } else {
            // 修改客户
            getUpdateClient(this.editForm)
              .then(() => {
                Toast.success("修改客户成功");
                this.loading = false;
                this.$emit('submit-success');
                done(); // 允许对话框关闭
              })
              .catch(() => {
                Toast('修改失败，请重试');
                this.loading = false;
                done(false); // 阻止对话框关闭
              });
          }
        }
      } else {
        done(); // 其他操作（如取消）允许对话框关闭
      }
    }
  }
};
</script>

<style lang="less" scoped>
.history-select {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  padding: 6px 12px;
  max-height: 46px;
  cursor: pointer;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.history-select:hover {
  border-color: #3a71ff;
  box-shadow: 0 2px 12px 0 rgba(58, 113, 255, 0.1);
}

.history-select span {
  font-size: 0.9rem;
  color: #333;
}

.history-select.disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid #e4e7ed;
}

.popup-header h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: bold;
  color: #333;
}

.popup-header .van-icon {
  cursor: pointer;
  color: #999;
}

.popup-header .van-icon:hover {
  color: #333;
}
</style>
